var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToileting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 1.5H5.25C4.25544 1.5 3.30161 1.89509 2.59835 2.59835C1.89509 3.30161 1.5 4.25544 1.5 5.25V16.5H9V5.875C9 4.1075 9.63375 2.53125 10.625 1.5ZM13.375 0.25C15.7913 0.25 17.75 2.76875 17.75 5.875C17.75 8.98125 15.7913 11.5 13.375 11.5H10.25V17.75H0.25V5.25C0.25 3.92392 0.776784 2.65215 1.71447 1.71447C2.65215 0.776784 3.92392 0.25 5.25 0.25H13.375ZM10.25 5.875V10.25H13.375C15.0225 10.25 16.5 8.35 16.5 5.875C16.5 3.4 15.0225 1.5 13.375 1.5C11.7275 1.5 10.25 3.4 10.25 5.875Z",
    fill: "#3C5366"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToileting);
export default __webpack_public_path__ + "static/media/toileting.a06201ebe28f83a1613a42541c68f675.svg";
export { ForwardRef as ReactComponent };